
import { UserProfile } from "@/types/profile";
import { UseFormRegister } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface PromoterProfileFormProps {
  register: UseFormRegister<UserProfile>;
}

export const PromoterProfileForm = ({ register }: PromoterProfileFormProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Promoter Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="company_name">Organization Name</Label>
          <Input
            id="company_name"
            {...register("company_name")}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="bio">About Your Events</Label>
          <Textarea
            id="bio"
            {...register("bio")}
            placeholder="Tell people about the types of events you organize..."
            className="min-h-[100px]"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="website">Website</Label>
          <Input
            id="website"
            type="url"
            {...register("website")}
          />
        </div>
      </CardContent>
    </Card>
  );
};
